import { useEffect, useState } from "react";
import { CENTRE } from "../../common/constants";
import { Alert, Button, Grid, Snackbar, TextField } from "@mui/material";
import HorizontalNav from "../../components/HorizontalNav";
import {
  textboxStyle,
} from "../../utils/styleObjs";
import { useNavigate } from "react-router-dom";

const BadgePrint = () => {
  const [sp, setSp] = useState("");
  const [sewadarBadge, setSewadarBadge] = useState("");
  const [snack, setSnack] = useState({
    open: false,
    severity: "success",
    msg: "",
  });
  const history = useNavigate()

  const onFieldChange = (val) => {
    setSewadarBadge(val);
  };
  const navLinks = [{ key: 0, label: "Home", path: "/home" }];

  useEffect(() => {
    setSp(localStorage.getItem(CENTRE));
  }, [sp]);

  return (
    <>
      <Snackbar
        open={snack.open}
        autoHideDuration={6000}
        onClose={() => setSnack({ ...snack, open: false })}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.severity}
          sx={{ width: "100%" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
      <HorizontalNav navLinks={navLinks} pageName="Badge Print Form" />
      <h2>Sewadar Details</h2>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={4}
        mb={2}
      >
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <TextField
            placeholder="SewadarID1,SewadarID2...(Max 10 IDs)"
            onChange={(e) => {
              const input = e.target.value;
              const values = input.split(',').filter(id => id.trim() !== '');

              if (values.length <= 10) {
                onFieldChange(input);
              } else {
                setSnack("Maximum of 10 sewadar ID's are allowed")
              }
            }}
            fullWidth
            sx={textboxStyle}
            value={sewadarBadge}
          />
        </Grid>
        <Grid item lg={2} md={3} sm={4} xs={8}>
          <Button fullWidth variant="contained" onClick={() => history("/badgePrintPage", { state: { sewadarIds: sewadarBadge.split(',').filter(id => id.trim() !== '') } })}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default BadgePrint;
